import React from 'react';
import { PayingOffInterest, PartialRepayment, ErrorBox } from './Sidebar';
import { CalculatorSection } from './../Calculators/Sections';
import { TextInput, RangerInput } from './../Form/index';
import { toCurrency } from './../../services/Formats';
import { config } from './../../config/config';
const { colors, bkColors } = config();

export const HousePrice = ({ input, onChangeInput }) => (
  <CalculatorSection className="section-future-price" icon='house-price2019'>
    <div className="title" style={{ backgroundColor: '#0e7c88' }}>
      Future house price
    </div>
    {(input.housePrice > 5100000) ? (
      <div className="section-row">
        <div style={{ margin: '20px 0px', width: '100%' }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The maximum property value allowed is £5,100,000
          </ErrorBox>
        </div>
      </div>
    ): false}
    <div className="section-row">
      <div className="column-icon clr2 pd">
        <img src="images/icon-house-pct.png" />
      </div>
      <div className="pad column-cell">
        <div>
          <div className="label">Future value (%)</div>
          <div style={{ fontSize: '0.6rem', paddingRight: 10 }}>
            See a projection of the future value of your
            client’s home with an annual average
            increase or decrease of -5 to 5%
          </div>
        </div>

        <div>
          <div style={{ marginLeft:16, marginRight: 16 }}>
            {/*<RangerInput*/}
            {/*    className="ranger"*/}
            {/*    color={colors.futureHousePrice}*/}
            {/*    value={input.futureHousePricePct} min={-5} max={5} div={4} type='float'*/}
            {/*    inactiveColor='#bbbbbb' withLabel={true}*/}
            {/*    onChange={val => { onChangeInput('futureHousePricePct', val) }}*/}
            {/*  />*/}
            <TextInput
              width={150}
              style={{ textAlign: 'right', width: 120 }}
              type="number"
              prefixes="%"
              value={input.futureHousePricePct}
              min={-5}
              max={5}
              onChange={val => { onChangeInput('futureHousePricePct', val) }}
            />
          </div>
        </div>
      </div>
    </div>
  </CalculatorSection>
);

export const RepaymentOptions = ({ input, output, onChangeInput }) => {

  const validLoan = !isNaN(input.loanTaken) && parseInt(input.loanTaken,10) > 0
  const validCapitalValue = !isNaN(input.capitalValue) && parseInt(input.capitalValue,10) > 0;

  const hasError = !validLoan || !validCapitalValue || output.yearlyCapitalValue > output.maxYearlyLoan;
  return (
    <CalculatorSection className="section-repayment" icon='repayment2019'>
      <div className="title" style={{ backgroundColor: '#51bba4' }}>Partial repayment</div>

      <div className="no-padding">
        <PayingOffInterest>
          {process.env.REACT_APP_PAYING_INTEREST ? (
            <div className="section-row">
              <div className="pad" style={{ paddingTop: 20 }}>
                <div className="label">
                  Paying interest<br />
                  {isNaN(output.monthlyInterestRepayment) ? false :
                    <span>&pound;{output.monthlyInterestRepayment} a month</span>
                  }
                </div>
                <div>
                  {input.stopPayingOffInterest > 0 ? [
                    <div key={0}>
                      <RangerInput
                        className="ranger"
                        value={input.stopPayingOffInterest} min={1} max={15}
                        color={colors.payingOffInterest} inactiveColor='#bbb' withLabel={true}
                        onChange={val => { onChangeInput('stopPayingOffInterest', val) }}
                      />
                    </div>,
                    <div key={2} style={{ marginTop:20, fontSize: 12, textAlign: 'left', color: '#000' }}>
                      Choose for how many years...
                    </div>
                  ]: false}
                </div>
              </div>
            </div>
          ) : false}

        </PayingOffInterest>
        <PartialRepayment>
          <div className="section-row" style={{ paddingTop: 0, marginTop: 0 }}>
            <div className="column-icon clr3">
              <img src="images/icon-pounds-arrow.png" />
            </div>

            <div className="pad column-cell">
              <div>
                <div className="section-row">
                  <div className="label">
                    <div style={{ paddingBottom: 10, fontWeight: 'bold' }}>
                      Input annual amount &nbsp;
                      {(hasError && !isNaN(output.yearlyCapitalValue / input.loanTaken)) ? (
                        <span>({parseInt(100 * output.yearlyCapitalValue / input.loanTaken, 10)}%)</span>
                      ): false}
                    </div>
                  </div>
                  <div style={{ marginTop:8, marginLeft: 16, marginRight: 16}}>
                    <TextInput
                      width={150} border={`1px ${colors.partialRepayment} solid`} color={colors.partialRepayment}
                      type="currency" prefixes="&pound;" value={input.capitalValue}
                      onChange={val => { onChangeInput('capitalValue', val) }}
                    />
                  </div>
                </div>
                <div>
                  {(hasError) ? (
                    <ErrorBox>
                      You can only repay a maximum
                      of 10% of the loan a year, please enter an amount
                      less than £{toCurrency(parseInt(output.maxYearlyLoan, 10))}
                    </ErrorBox>
                  ) : false}
                </div>
                {(!hasError && validLoan && validCapitalValue) ? [
                  <div className="section-row">
                    <div key={1} className="label">
                      For how many years?
                    </div>
                    <div key={0} style={{ marginTop:8, marginLeft: 16, marginRight: 16}}>
                      {/*<RangerInput*/}
                      {/*  className="ranger"*/}
                      {/*  value={input.stopPartialRepayment} min={1} max={15}*/}
                      {/*  color={'#51bba4'} inactiveColor='#bbb' withLabel={true}*/}
                      {/*  onChange={val => { onChangeInput('stopPartialRepayment', val) }}*/}
                      {/*/>*/}
                      <TextInput
                        width={150}
                        style={{ textAlign: 'right', width: 150 }}
                        type="number"
                        prefixes=""
                        value={input.stopPartialRepayment}
                        min={1}
                        max={25}
                        onChange={val => { onChangeInput('stopPartialRepayment', val) }}
                      />
                    </div>
                  </div>
                ]: false}
              </div>
            </div>
          </div>
        </PartialRepayment>
      </div>
    </CalculatorSection>
  );
};


/*<div className="section-row">
            <div className="pad" style={{ paddingTop: 10 }}>
                <div style={{ paddingBottom: 10, fontWeight: 'bold' }}>Client payment frequency</div>
            </div>
          </div>
          <div className="section-row">
            <div className="column" style={{ paddingTop: 0, paddingBottom: 0 }}>
              <RadioButton color='#000' value='1' checked={parseInt(input.period, 10) === 1} onChange={val => onChangeInput('period', val)}>Monthly</RadioButton>
              <RadioButton color='#000' value='2' checked={parseInt(input.period, 10) === 2} onChange={val => onChangeInput('period', val)}>Bi-monthly</RadioButton>
            </div>
            <div className="column" style={{ paddingTop: 0, paddingBottom: 0 }}>
              <RadioButton color='#000' value='3' checked={parseInt(input.period, 10) === 3} onChange={val => onChangeInput('period', val)}>Quarterly</RadioButton>
              <RadioButton color='#000' value='6' checked={parseInt(input.period, 10) === 6} onChange={val => onChangeInput('period', val)}>Bi-annually</RadioButton>
            </div>
            <div className="column" style={{ paddingTop: 0, paddingBottom: 0 }}>
              <RadioButton color='#000' value='12' checked={parseInt(input.period, 10) === 12} onChange={val => onChangeInput('period', val)}>Annually</RadioButton>
            </div>
          </div>*/



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/LeftPanel.js